import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { UpdateSingleBillManager, UpdateSingleBillPageStore } from '@ctct/application-layer';
import type { UpdateSingleBillHooks } from '@ctct/state-client-layer';
import { useCreateSingleBill, useSingleBill, useUpdateSingleBill } from '@ctct/state-server-layer';

interface Props {
  pageStore: UpdateSingleBillPageStore;
  initializer: Pick<UpdateSingleBillManager, 'updateSingleBillInit'>;
  hooks: UpdateSingleBillHooks;
}

export function useSubmitSingleBillWidget({ initializer, pageStore, hooks }: Props) {
  const singleBill = useSingleBill();
  const updateSingleBill = useUpdateSingleBill();
  const createSingleBill = useCreateSingleBill();
  const { t } = useTranslation();

  const componentProps = useMemo(
    () => ({
      ...initializer.updateSingleBillInit({
        pageStore,
        queries: [singleBill],
        mutations: [updateSingleBill, createSingleBill],
        t,
      }),
      hooks,
    }),
    [createSingleBill, hooks, initializer, pageStore, singleBill, t, updateSingleBill]
  );

  return componentProps;
}

export type SubmitSingleBillWidgetProps = ReturnType<typeof useSubmitSingleBillWidget>;
